import React from 'react';

export default function VolumeTrendChart({ dailyDocs = [] }) {
    const sorted = [...dailyDocs].sort((a, b) => (a.date || '').localeCompare(b.date || ''));
    const max = Math.max(1, ...sorted.map((d) => d.total_cases_created || 0));

    if (sorted.length === 0) {
        return (
            <section className="dashboard-section">
                <h3>Volume — last 30 days</h3>
                <p className="dashboard-empty">No activity yet.</p>
            </section>
        );
    }

    return (
        <section className="dashboard-section">
            <h3>Volume — last {sorted.length} days</h3>
            <div className="volume-trend">
                {sorted.map((d) => (
                    <div
                        key={d.date}
                        className="trend-bar"
                        title={`${d.date}: ${d.total_cases_created || 0} new`}
                        style={{ height: `${((d.total_cases_created || 0) / max) * 100}%` }}
                    />
                ))}
            </div>
        </section>
    );
}
